export enum AssetType {
  INDStocks = 'IND Stocks',
  USStocks = 'US Stocks',
  MutualFund = 'Mutual Fund',
  PPF = 'PPF',
  FD = 'Fixed Deposit',
}
